import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { useApp } from "../../context/AppContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { onLogin } = useApp();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/google/session", { session_id: sid })
      .then(async ({ data }) => {
        await onLogin(data);
        window.history.replaceState(null, "", window.location.pathname);
        nav(["owner", "admin"].includes(data.role) ? "/admin" : "/account", { replace: true });
      })
      .catch(() => nav("/login?error=google", { replace: true }));
  }, [location.hash, nav, onLogin]);
  return null;
}
